import { allRegions, allTags, allYears, type SortKey } from "@/lib/data";

export interface FilterState {
  region: string;
  year: string;
  tag: string;
}

interface CategoryFilterProps {
  filter: FilterState;
  setFilter: (f: FilterState) => void;
  sort: SortKey;
  setSort: (s: SortKey) => void;
  onReset: () => void;
}

const selectClass =
  "h-10 px-3 rounded-md text-sm bg-background-50 border border-background-200 text-foreground-800 focus:border-primary-400 focus:outline-none cursor-pointer";

export default function CategoryFilter({
  filter,
  setFilter,
  sort,
  setSort,
  onReset,
}: CategoryFilterProps) {
  return (
    <div className="bg-background-50 rounded-lg border border-background-200 p-4 md:p-5">
      <div className="flex flex-wrap items-center gap-3">
        <div className="flex items-center gap-2">
          <span className="text-sm text-foreground-500 whitespace-nowrap">地区</span>
          <select
            className={selectClass}
            value={filter.region}
            onChange={(e) => setFilter({ ...filter, region: e.target.value })}
          >
            <option value="">全部地区</option>
            {allRegions.map((r) => (
              <option key={r} value={r}>
                {r}
              </option>
            ))}
          </select>
        </div>

        <div className="flex items-center gap-2">
          <span className="text-sm text-foreground-500 whitespace-nowrap">年代</span>
          <select
            className={selectClass}
            value={filter.year}
            onChange={(e) => setFilter({ ...filter, year: e.target.value })}
          >
            <option value="">全部年代</option>
            {allYears.map((y) => (
              <option key={y} value={String(y)}>
                {y} 年
              </option>
            ))}
            <option value="older">2023 年及以前</option>
          </select>
        </div>

        <div className="flex items-center gap-2">
          <span className="text-sm text-foreground-500 whitespace-nowrap">排序</span>
          <select
            className={selectClass}
            value={sort}
            onChange={(e) => setSort(e.target.value as SortKey)}
          >
            <option value="popularity">按热度</option>
            <option value="updated">按更新时间</option>
            <option value="rating">按评分</option>
            <option value="year">按年份</option>
          </select>
        </div>

        <button
          type="button"
          onClick={onReset}
          className="h-10 px-4 rounded-md text-sm text-foreground-600 bg-background-100 hover:bg-background-200 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1"
        >
          <i className="ri-refresh-line" />
          重置
        </button>
      </div>

      <div className="mt-4 pt-4 border-t border-background-200 flex flex-wrap items-center gap-2">
        <span className="text-sm text-foreground-500 whitespace-nowrap mr-1">热门标签</span>
        <button
          type="button"
          onClick={() => setFilter({ ...filter, tag: "" })}
          className={`px-3 py-1 rounded-full text-xs cursor-pointer transition-colors ${
            filter.tag === ""
              ? "bg-primary-600 text-background-50"
              : "bg-background-100 text-foreground-600 hover:bg-background-200"
          }`}
        >
          全部
        </button>
        {allTags.map((t) => (
          <button
            key={t}
            type="button"
            onClick={() => setFilter({ ...filter, tag: filter.tag === t ? "" : t })}
            className={`px-3 py-1 rounded-full text-xs cursor-pointer transition-colors ${
              filter.tag === t
                ? "bg-primary-600 text-background-50"
                : "bg-background-100 text-foreground-600 hover:bg-background-200"
            }`}
          >
            {t}
          </button>
        ))}
      </div>
    </div>
  );
}